export enum DoorBuilderOptionsEnum {
  DO_NOT_DRILL = 'DO NOT DRILL',
  BLUM_1INCH = 'BLUM 1INCH',
}
